import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=5666f469&scoped=true"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"
import style0 from "./Expenses.vue?vue&type=style&index=0&id=5666f469&prod&scoped=true&lang=css"
import style1 from "./Expenses.vue?vue&type=style&index=1&id=5666f469&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5666f469",
  null
  
)

export default component.exports